/* miscellaneous data processing functions */
/*
  Make a list of strings human readable, returns a string
  ['dog'] => dog
  ['dog', 'cat'] => dog and cat
  ['dog', 'cat', 'mouse'] => dog, cat, and mouse
  // also provided by humanize-plus as "oxford"
*/
export const humanizeList = (strings) => {
  const length = strings.length;
  if (length === 1) {
    return `${strings[0]}`;
  } else if (length === 2) {
    return `${strings[0]} and ${strings[1]}`;
  } else if (length > 2) {
    const prefix = strings.slice(0, -1).join(', ');
    return `${prefix}, and ${strings[length - 1]}`;
  } else { // empty list
    return '';
  }
}

// naming
export const idToDescription = (id) => {
  switch (id) {
    case "bau":
      return "Business As Usual";
    case "primary":
      return "Scenario 1";
    case "secondary":
      return "Scenario 2";
    default:
      return "mystery";
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js